module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Once-Upon-A-Time-In-Venice.d2ab033.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Once-Upon-A-Time-In-Venice.jpg
// module id = 7BdR
// module chunks = 0